module.exports = __webpack_public_path__ + "static/img/bg-pt.d3dc4042.png";